import { executeRequest, JFSRequest } from '@jfs/network'
import { dateFormatter, DateFormatTypes, isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { getAcceptableStatusForFiu } from './getFiuMakerList'

const getModifiedApplicationState = (state) => {
  const mapping = { OPS_CHECKER: 'Pending', APPROVED: 'Approved', OPS_REJECT: 'Rejected', COMPLETED: 'Completed' }
  return mapping[state] ?? state
}

const parser = (dataList: any, count: number) => {
  let parsedList: any[] = []
  dataList?.map((data) => {
    parsedList.push({
      applicationId: data?.applicationId,
      auditType: data?.auditDto?.auditType,
      applicationStatus:
        data?.applicationState === 'OPS_CHECKER'
          ? 'Pending For Approval'
          : getModifiedApplicationState(data?.applicationState),
      assignee: data?.opsCheckerUser?.username,
      authorisedSignatory: data?.auditDto?.authorisedSignatory,
      beneficialOwnerDetails: data?.auditDto?.beneficialOwnerDetails,
      businessProfile: data?.auditDto?.businessProfile,
      comments: data?.comments,
      createdAt: dateFormatter(data?.createdAt, DateFormatTypes.TIME_STAMP),
      createdBy: data?.opsMakerUser?.username,
      directorDetails: data?.auditDto?.directorDetails,
      identificationNumber: data?.auditDto?.identificationNumber,
      taskInstanceId: data?.taskInstanceId,
      processInstanceId: data?.processInstanceId,
    })
  })
  return { list: parsedList, count }
}

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return parser(data?.processInstances, data?.totalItems ?? 0)
}

const getFiuCheckerListReq = (
  selectedDateInfo: any,
  pagination: any,
  applicationStatus: any,
  tokens: any,
  auditTypes,
  searchBy: string = '',
  searchKey: string = '',
) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getGlobalCheckerList),
    method: 'POST',
    cache: false,
    body: {
      auditSearchFilter: {
        pageNumber: searchBy && searchBy?.length > 0 && searchKey?.length > 0 ? 1 : pagination.number,
        pageSize: 10,
        endDate: dateFormatter(selectedDateInfo.toDate, DateFormatTypes.YYYYMMDD)?.trim(),
        startDate: dateFormatter(selectedDateInfo.fromDate, DateFormatTypes.YYYYMMDD)?.trim(),
        ...(applicationStatus.length > 0 &&
          !applicationStatus?.includes('ALL') && {
            applicationState: getAcceptableStatusForFiu(applicationStatus),
          }),
        ...(searchBy?.length > 0 && searchKey?.length > 0 && { [searchBy]: searchKey }),
        ...(auditTypes.length > 0 &&
          !auditTypes?.includes('ALL') && {
            auditType: auditTypes,
          }),
        startDateOrder: 'Desc',
        requestType: ['AUDIT'],
      },
    },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then((response) => responseParser(response))
    .catch((error) => {
      throw error
    })
}

export { getFiuCheckerListReq }
